import { useContext, useEffect, useRef } from "react";
import globalStates from "../../utils/global";
import "./RecipeScreen1alt.css"
import { IconRecipe1, ImgRecipeScreen1, ImgStoryScreen1d } from "../../assets";

const RecipeScreen1alt = () =>{

    const openLinkHandler = (link:any) =>{
        // console.log("link", link)
        window.open(link, '_blank');
    }

    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    
    // const businessDetailImagesImg = businessDetailImages && businessDetailImages.screenBannerImg;

    const screenWebsiteRef = useRef(null) as any;
    // console.log({})
    useEffect(()=>{
        const handleScroll =()=>{
            const setScreensOffset = globalContext && globalContext.setScreensOffset;
            const screenWebsite = screenWebsiteRef.current.getBoundingClientRect();
            const top = screenWebsite.top;
            const bottom = screenWebsite.bottom;
            const offset = globalContext && globalContext.windowHeight;
            setScreensOffset((prev:any)=>{return {...prev, 
                isOffsetscreenWebsite: false, bottom, offset, top
            }});
            if(top < (-1*0.005*offset) ){
                setScreensOffset((prev:any)=>{return {...prev, bottom, offset, top,
                    isOffsetscreenWebsite: true,
                }});
            };
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [globalContext])

    const componentData = {
        background: {
            image: {
                src: ImgRecipeScreen1,
                alt: ""
            }
        },
        shield: {

        },
        content: {
            left: {
                title: "Find RECIPES"
            },
            right: {
                icon: {
                    src: IconRecipe1,
                    alt: ""
                },
                handlers: {
                    findHere: ()=>{
                        openLinkHandler("https://www.instagram.com/s/aGlnaGxpZ2h0OjE4MDAwMTAyODIzNDIwNjcx?igsh=M3ZvcjE4b2dlYTcz")
                    }
                }
            }
        }
    }
    
    return(
        <>
            <div 
            ref={screenWebsiteRef} 
            className={`${windowWidthClass}-recipe-screen-1-alt wrapper`}>

                <div className="background">
                    <div className="frame">
                        <img
                            alt = {componentData.background.image.alt}
                            src = {componentData.background.image.src}
                        />
                    </div>
                </div>
                <div className="shield">

                </div>
                <div className="content display grid">
                    <div className="text-wrapper left">
                        <h1>{componentData.content.left.title}</h1>
                    </div>
                    <div className="text-wrapper right">
                        <div className="frame">
                            <img 
                            src={componentData.content.right.icon.src}
                            alt={componentData.content.right.icon.alt}
                            />
                             <h2
                                onClick={()=>componentData.content.right.handlers.findHere()}
                             >Find here</h2>
                        </div>
                       
                    </div>
                    
                </div>

            </div>
        </>
        
    )
};

export default RecipeScreen1alt;